import axios from 'axios';

const baseURL = process.env.API_URL;

const request = axios.create({
    withCredentials: true,
    baseURL,
    timeout: 1000 * 30 //30 seconds
});

if (process.env.NODE_ENV === 'development') {
    const MockAdapter = require('axios-mock-adapter');
    const vacancies = require('./mocks/CurrentOpenings.xml');

    const vacanciesUrl = '/backend/get-vacancies.php';
    const mock = new MockAdapter(request);

    mock.onGet(vacanciesUrl).reply(200, vacancies);
    mock.onAny().passThrough();
}

export default request;
